import { SKILL_NAMES } from 'js/src/agent/skills/skillNames';
import { TOOL_NAMES } from 'js/src/agent/toolNames';
import type { Skill } from '../types';

export const documentBasicsSkill: Skill = {
    name: SKILL_NAMES.documentBasics,
    description:
        'The user attached a document (PDF, PPT, DOC). Load BEFORE analyzing it or building from it.',
    kind: 'howto',
    surfaces: ['sketch'],
    get instructions(): string {
        return `# Document Basics

For building a video from a document the user attached. The document supplies the
content and often media; the video kind (and its skill) is whatever the user asked
for.

## Scope the document first
Analyze the document's structure and scope before building. If it's long, ask what
to focus on or which section becomes the video — use \`${TOOL_NAMES.askUserQuestion}\`, with
intentional options likely to clear up the ambiguity.

## The document's media
Analyze every piece of media the document contains and understand it in context:
how does it fit the story of the video?
- **Figures — tables, charts, diagrams, illustrations of specific concepts — need
  maximum visibility.** Pick scene designs that show the whole media without
  cropping or animation (e.g. fullbleed in landscape), consider the media's
  dimensions against the container's, and set Ken Burns to \`none\`.
- Media that is more stock-like in nature (photos, general imagery) can be used
  liberally, like any other media.`;
    },
};
